import { FeaturedGif1, FeaturedGif2, FeaturedGif3, FeaturedShape } from '@/assets/images'
import { ClaimSection } from '@/components/sections/claim-section'
import { CompaniesSection } from '@/components/sections/companies-section'
import { FeaturedItem } from '@/components/sections/featured-item'
import { HeroSection } from '@/components/sections/hero-section'
import { JobsSection } from '@/components/sections/jobs-section'
import { env } from '@/config/env'

export function TalentPage() {
  return (
    <div className="talent-page">
      <HeroSection
        title="Seeking a new tech role or hiring?"
        description="Join BrightSource and connect instantly!"
      />

      <CompaniesSection />
      <TalentFeatured />
      <JobsSection />
      <ClaimSection />
    </div>
  )
}

// CTA targets: legacy shipped these buttons with no handler at all. `/apply` is the talent
// app's registration entry (anonymous-accessible OnboardingPage); `/job-search` is its search
// page (login-gated upstream). See docs/features/landing-coverage.md, "Outbound links".
function TalentFeatured() {
  return (
    <section className="talent-featured">
      <div className="talent-featured-inner container">
        <FeaturedItem
          title="You do you. Your profile should too."
          description="Create a profile that highlights your skills and preferences, then apply anywhere with
            one click."
          buttonText="Create Profile"
          buttonHref={`${env.talentAppUrl}/apply`}
          imgSrc={FeaturedGif1}
        />

        <FeaturedItem
          reverse
          title="Find work that works for you."
          description="A personalized - and completely private - job search, with all the info you care about
        upfront."
          buttonText="Browse jobs"
          buttonHref={`${env.talentAppUrl}/job-search`}
          imgSrc={FeaturedGif2}
        />

        <FeaturedItem
          title="Dreams do come true!"
          description="Companies can find you and pitch their opportunity. Connect directly with founders and
        recruiters, without the middlemen."
          buttonText="Create Profile"
          buttonHref={`${env.talentAppUrl}/apply`}
          imgSrc={FeaturedGif3}
        />
      </div>

      <div className="talent-featured-bottom">
        <img src={FeaturedShape} alt="" />
      </div>
    </section>
  )
}
